import { Button } from 'antd';
import styled from 'styled-components';
import { NftAvatarBlock as NftAvatarBlockComponent } from 'components/Shared/NftAvatarBlock';
import { NftAvatarBlockSkeleton as NftAvatarBlockComponentSkeleton } from 'components/Shared/NftAvatarBlock/Skeleton';
import { NftMedia as NftMediaComponent } from 'components/Shared/NftMedia';
import { NftMediaSkeleton as NftMediaComponentSkeleton } from 'components/Shared/NftMedia/Skeleton';

export const NftMedia = styled(NftMediaComponent)`
  border-radius: 32px;
`;

export const NftMediaSkeleton = styled(NftMediaComponentSkeleton)`
  border-radius: 32px;
`;

export const NftAvatarBlock = styled(NftAvatarBlockComponent)`
  flex: 1;
`;

export const NftAvatarBlockSkeleton = styled(NftAvatarBlockComponentSkeleton)`
  flex: 1;
`;

export const MenuToggle = styled(Button)`
  font-size: 12px;
  color: var(--v3-black-45);
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 1px solid var(--v3-black-45);
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover,
  &:active,
  &:focus {
    color: var(--v3-black-45);
    border: 1px solid var(--v3-black-45);
  }
`;

export const FlexBlock = styled.div<{ $column?: boolean; $gap?: number }>`
  display: flex;
  justify-content: space-between;
  flex-direction: ${props => (props.$column ? 'column' : 'row')};
  gap: ${props => props.$gap || 0}px;
`;

export const NftTitle = styled.h4`
  font-weight: 700;
  font-size: 32px;
  line-height: 36px;
  margin: 32px 0 16px 0;
  color: var(--v3-text-color);
`;

export const NftPage = styled.div`
  height: 100%;
  display: flex;
  justify-content: center;
  gap: 52px;
  margin: 0 auto;
  overflow: auto;
  position: relative;
  width: 100%;
  padding-top: 62px;
`;

export const NftPageLeftSide = styled.div`
  flex: 1;
  max-width: 35%;
  padding-bottom: 32px;
`;

export const NftPageRightSide = styled.div`
  flex: 1;
  position: relative;
  max-width: 40%;
`;

export const NftPageRightSideInner = styled.div`
  position: fixed;
  top: 62px;
  left: 50%;
  max-width: 40%;
  width: 40%;
  overflow: auto;
  height: -webkit-fill-available;
`;

export const BlankSpace = styled.div`
  height: 32px;
`;
